import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FezaDataService } from '../../services/fezadata.service';
import { FileService } from '../../services/file.service';
import { environment } from '../../../environments/environment';
import { S1DataService } from '../../services/s1data.service';
import { LoadingProgress } from '../../models/ILoadingProgress';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: 'settings-file',
    templateUrl: './settings-file.component.html',
    styleUrls: ['./settings-file.component.css']
})
export class SettingsFileComponent implements OnInit {
    @Input() titleLabel: string;
    @Input() uploadLabel: string;//<--- optional, if you only want a download link instead of up & down
    @Input() downloadLabel: string;
    @Input() configPathName: string;
    @Input() downloadFileName: string;
    @Input() extraUrlParams: string;

    fileConfigBasePath: string;
    results: string;
    form: FormGroup;
    loading: boolean;

    constructor(
        private fb: FormBuilder,
        private fezaService: FezaDataService,
        private fileService: FileService,
        private dataService: S1DataService) {
        this.fileConfigBasePath = environment.fileConfigBasePath;
        this.form = this.fb.group({ onFileUpload: null });
    }

    ngOnInit() {
    }

    onFileChanged(event) {
        if (event.target.files.length > 0) {
            let file = event.target.files[0];
            this.form.get('onFileUpload').setValue(file);
        }
    }

    onGetFile() {
      this.fileService.downloadSecureFile(this.fileConfigBasePath + this.configPathName + (this.extraUrlParams || ""), this.downloadFileName);
    }

    private prepareSave(fileName): FormData {
        if (!this.form.get(fileName).value)
            return null;
        let input = new FormData();
        input.append('file', this.form.get(fileName).value);
        return input;
    }

    onSubmitBlend() {
      this.loading = true;
      this.fezaService.UploadFile(this.fileConfigBasePath + this.configPathName + (this.extraUrlParams || ""), this.prepareSave("onFileUpload")).subscribe(res => {
            this.loading = false;
            this.results = res;
        },
            err => {
                this.loading = false;
                this.results = "Error:" + onerror;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/settings-file/settings-file.component.ts